import React, { useEffect, useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { getRoomCategories, deleteRoomCategory } from "services/CategoryService";

const RoomCategoryList = () => {
  const [roomCategoris, setRoomCategory] = useState([]);
  const [filteredRoomCategory, setFilteredRoomCategory] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [deleteRoomCategoryId, setDeleteRoomCategoryId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  
  const navigate = useNavigate();

  useEffect(() => {
    getRoomCategoryList();
  }, []);

  useEffect(() => {
      handleSearch();
    }, [searchQuery]);
  
    const getRoomCategoryList = () => {
      getRoomCategories().then((response) => {
        if (response && response.data.success) {
          setRoomCategory(response.data.roomcategories);
          setFilteredRoomCategory(response.data.roomcategories);
        }
      });
    };
  
    const handleSearch = () => {
      const query = searchQuery.toLowerCase();
      const filtered = roomCategoris.filter(
        (roomCategory) =>
          roomCategory.hote_id?.toLowerCase().includes(query) ||
          roomCategory.roo_type?.toLowerCase().includes(query) 
      );
      setFilteredRoomCategory(filtered);
      setPage(0);
    };
  
    const handleChangePage = (newPage) => setPage(newPage);
    const handleRowsPerPageChange = (e) => {
      setRowsPerPage(parseInt(e.target.value, 10));
      setPage(0);
    };
  
    const paginatedRoomCategory = filteredRoomCategory.slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
  
    const handleCreate = () => {
      navigate("/add-room-category", { state: { isEdit: false } });
    };
  
    const handleEdit = (category) => {
      navigate("/add-room-category", { state: { isEdit: true, editFormData: category } });
    };
   
    const deleteCategory = (id) => {
      setDeleteRoomCategoryId(id);
      setShowDeleteModal(true);
    };
    
    const confirmDeleteRoomCategory = () => {
  
      deleteRoomCategory(deleteRoomCategoryId).then((response) => {
        if (response && response.data.success) {
          setShowDeleteModal(false);
          getRoomCategoryList();
        }
      });
      
    };

  return (
    <>
      <section className="content-header">
        <div className="header-icon">
          <i className="fa fa-hotel"></i>
        </div>
        <div className="header-title">
          <h1>Manage Room Category</h1>
          <small>Room Category List</small>
        </div>
      </section>

      <section className="content">
        <div className="row">
          <div className="col-lg-12 pinpin">
            <div className="buttonexport" id="buttonlist">
              <Link className="btn btn-add" to="/add-room-category">
                <i className="fa fa-plus"></i> Add Room Category
              </Link>
            </div>
            <div className="card lobicard mt-2" data-sortable="true">
              <div className="card-header">
                <div className="card-title custom_title">
                  <h4>Room Category List</h4>
                </div>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table
                    id="dataTableExample1"
                    className="table table-bordered table-striped table-hover"
                  >
                    <thead className="back_table_color">
                      <tr class="info">
                        <th>Sno. </th>
                        <th>Hotel Name </th>
                        <th>Room Category </th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                    {filteredRoomCategory.length > 0 ? (
                        filteredRoomCategory.map((category, index) => (
                        <tr>
                        <td>{index+1}</td>
                        <td>{category.name}</td>
                        <td>{category.room_type}</td>
                        <td>
                          <button
                            type="button"
                            className="btn btn-add btn-sm"
                            data-toggle="modal"
                            data-target="#customer1"
                            onClick={(e) => {
                              e.stopPropagation();
                              handleEdit(category);
                            }}
                          >
                            <i className="fa fa-pencil"></i>
                          </button>
                          <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            data-toggle="modal"
                            data-target="#customer2"
                            onClick={(e) => {
                              e.stopPropagation();
                              deleteCategory(category.id);
                            }}
                          >
                            <i className="fa fa-trash-o"></i>{" "}
                          </button>
                        </td>
                      </tr>
                       ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No agents found.
                          </td>
                        </tr>
                         )}   
                      
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {showDeleteModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div
            className="modal-dialog modal-lg"
            role="document"
            style={{ zIndex: "9999" }}
          >
            <div className="modal-content">
              <div className="modal-header modal-header-primary">
                <h3>
                  <i className="fa fa-user m-r-5"></i> Delete Room Category
                </h3>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                  onClick={(e) => {
                    setShowDeleteModal(false);
                  }}
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <form className="form-horizontal">
                      <div className="row">
                        <div className="col-md-12 form-group user-form-group">
                          <label className="control-label">Delete Room Category</label>
                          <div className="float-right">
                            <button
                              type="button"
                              className="btn btn-danger btn-sm mr-3"
                              onClick={(e) => {
                                e.stopPropagation();
                                setShowDeleteModal(false);
                              }}
                            >
                              NO
                            </button>
                            <button
                              type="button"
                              className="btn btn-add btn-sm"
                              onClick={(e) => {
                                e.stopPropagation();
                                confirmDeleteRoomCategory();
                              }}
                            >
                              YES
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger float-left"
                  data-dismiss="modal"
                  onClick={(e) => {
                    setShowDeleteModal(false);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

{/*{showDeleteModal && ( */}
    </>
  );
};

export default RoomCategoryList;
